export default "__VITE_ASSET__CrDKKXDj__"